import {PaymentRequestModel} from '../../models/paymentRequest/PaymentRequest.model';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {
  checkoutPayingForExistingOrderCheckoutPageLoadedSrc130Evid40,
  checkoutPayingForExistingOrderClickOnPayNowSrc130Evid41,
  checkoutPayingForExistingOrderShowHideOverviewSectionMobileViewSrc130Evid42,
  checkoutPayingForExistingOrderThankYouPageLoadedSrc130Evid43,
  checkoutPayingForExistingOrderPaylinkExpiredPopupSrc130Evid44,
  checkoutPayingForExistingOrderErrorMessageSrc130Evid45,
  checkoutPayingForExistingOrderClickOnCheckoutPoliciesSrc130Evid47,
  checkoutPayingForExistingOrderClickGoToCheckoutInErrorMessageSrc130Evid22,
  checkoutPayingForExistingOrderClickOnCtaInErrorMessageSrc130Evid153,
  checkoutPayingForExistingOrderCheckoutPageStartLoadingSrc130Evid53,
  checkoutClickOnRefreshPageInLoadingCheckoutFailPageSrc130Evid761,
} from '@wix/bi-logger-ecom-platform-data/v2';
import {PaymentRequestSettingsService} from './PaymentRequestSettingsService';
import {createBILogger, toBiAmount} from '../../utils/common/bi.util.common';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {Logger} from '@wix/web-bi-logger/dist/src/types';
import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {SPECS} from '../../../common/constants';

export class PaymentRequestBIService {
  private readonly biLogger: Logger;

  constructor(
    private readonly services: {
      siteStore: SiteStore;
      paymentRequestSettingsService: PaymentRequestSettingsService;
      viewerContext: ViewerContext;
    },
    controllerConfig: IWidgetControllerConfig
  ) {
    this.biLogger = this.services.viewerContext.isExperimentEnabled(SPECS.MoveCheckoutToViewerContext)
      ? createBILogger(controllerConfig, this.services.viewerContext)
      : this.services.siteStore.webBiLogger;
  }

  public checkoutPayingForExistingOrderCheckoutPageLoadedSrc130Evid40({
    paymentRequest,
  }: {
    paymentRequest: PaymentRequestModel;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderCheckoutPageLoadedSrc130Evid40({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        paymentRequestStatus: paymentRequest.status,
        amountLong: toBiAmount(paymentRequest.total.amount),
        currency: paymentRequest.currency,
        title: paymentRequest.title,
        description: paymentRequest.description,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        isPolicy: this.services.paymentRequestSettingsService.paymentRequestSettings.isThereAnyPolicyEnabled,
        expirationDate: paymentRequest.expirationDateTimeStamp,
      })
    );
  }

  public checkoutPayingForExistingOrderCheckoutPageStartLoadingSrc130Evid53({
    paymentRequest,
  }: {
    paymentRequest: PaymentRequestModel;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderCheckoutPageStartLoadingSrc130Evid53({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        paymentRequestStatus: paymentRequest.status,
        amountLong: toBiAmount(paymentRequest.total.amount),
        currency: paymentRequest.currency,
        title: paymentRequest.title,
        description: paymentRequest.description,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        isPolicy: this.services.paymentRequestSettingsService.paymentRequestSettings.isThereAnyPolicyEnabled,
        expirationDate: paymentRequest.expirationDateTimeStamp,
      })
    );
  }

  public checkoutPayingForExistingOrderClickOnPayNowSrc130Evid41({
    paymentRequest,
    activePaymentId,
  }: {
    paymentRequest: PaymentRequestModel;
    activePaymentId?: string;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderClickOnPayNowSrc130Evid41({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        paymentRequestStatus: paymentRequest.status,
        amountLong: toBiAmount(paymentRequest.total.amount),
        currency: paymentRequest.currency,
        title: paymentRequest.title,
        description: paymentRequest.description,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        isPolicy: this.services.paymentRequestSettingsService.paymentRequestSettings.isThereAnyPolicyEnabled,
        expirationDate: paymentRequest.expirationDateTimeStamp,
        selectedPaymentProvider: activePaymentId,
      })
    );
  }

  public checkoutPayingForExistingOrderShowHideOverviewSectionMobileViewSrc130Evid42({
    paymentRequest,
    action,
  }: {
    paymentRequest: PaymentRequestModel;
    action: string;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderShowHideOverviewSectionMobileViewSrc130Evid42({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        action,
      })
    );
  }

  public checkoutPayingForExistingOrderThankYouPageLoadedSrc130Evid43({
    paymentRequest,
  }: {
    paymentRequest: PaymentRequestModel;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderThankYouPageLoadedSrc130Evid43({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        paymentRequestStatus: paymentRequest.status,
      })
    );
  }

  public checkoutPayingForExistingOrderPaylinkExpiredPopupSrc130Evid44({
    paymentRequest,
  }: {
    paymentRequest: PaymentRequestModel;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderPaylinkExpiredPopupSrc130Evid44({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        paymentRequestStatus: paymentRequest.status,
        expirationDate: paymentRequest.expirationDateTimeStamp,
      })
    );
  }

  public checkoutPayingForExistingOrderErrorMessageSrc130Evid45({
    paymentRequest,
    errorMessage,
    paymentRequestId,
  }: {
    paymentRequest: PaymentRequestModel;
    errorMessage: string;
    paymentRequestId?: string;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderErrorMessageSrc130Evid45({
        orderId: paymentRequest?.orderId,
        orderPaymentRequestId: paymentRequest?.id ?? paymentRequestId,
        appId: paymentRequest?.source?.appId,
        externalId: paymentRequest?.source?.externalId,
        errorMessage,
        paymentRequestStatus: paymentRequest?.status,
      })
    );
  }

  public checkoutPayingForExistingOrderClickOnCheckoutPoliciesSrc130Evid47({
    paymentRequest,
    linkLocation,
    policyType,
  }: {
    paymentRequest: PaymentRequestModel;
    linkLocation: string;
    policyType: string;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderClickOnCheckoutPoliciesSrc130Evid47({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        externalId: paymentRequest.source?.externalId,
        linkLocation,
        policyType,
      })
    );
  }

  public checkoutPayingForExistingOrderClickGoToCheckoutInErrorMessageSrc130Evid22({
    paymentRequest,
  }: {
    paymentRequest: PaymentRequestModel;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderClickGoToCheckoutInErrorMessageSrc130Evid22({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        paymentRequestStatus: paymentRequest.status,
        externalId: paymentRequest.source?.externalId,
      })
    );
  }

  public checkoutPayingForExistingOrderClickOnCtaInErrorMessageSrc130Evid153({
    paymentRequest,
    errorMessage,
  }: {
    paymentRequest: PaymentRequestModel;
    errorMessage: string;
  }): void {
    void this.biLogger.report(
      checkoutPayingForExistingOrderClickOnCtaInErrorMessageSrc130Evid153({
        orderId: paymentRequest.orderId,
        orderPaymentRequestId: paymentRequest.id,
        appId: paymentRequest.source?.appId,
        paymentRequestStatus: paymentRequest.status,
        externalId: paymentRequest.source?.externalId,
        errorMessage,
      })
    );
  }

  public clickOnRefreshPageInLoadingCheckoutFailed() {
    void this.biLogger.report(checkoutClickOnRefreshPageInLoadingCheckoutFailPageSrc130Evid761({}));
  }
}
